import angular from 'angular';
import fineTuneCheckboxesComponent from './fineTuneCheckboxesComponent';
import 'components/sharpr/clearableInput/clearableInputModule';
import 'components/sharpr/checkboxList/checkboxListModule';

angular
	.module('sh.fineTuneCheckboxes', ['sh.clearableInput', 'sh.checkboxList'])
	.component('shFineTuneCheckboxes', fineTuneCheckboxesComponent());
